import { Checkbox, Switch } from "antd";
import dayjs from "dayjs";

export const renderCheckbox = checked => <Checkbox checked={checked} />

export const renderSwitch = checked => <Switch checked={!!checked} disabled size="small" />

export const renderDateTime = datetime => datetime ? dayjs(datetime).format("DD.MM.YYYY HH:mm.ss") : null

export const renderDate = datetime => datetime ? dayjs(datetime).format("DD.MM.YYYY") : null

export const renderNumber = value => (value && Number(value)) ? value : null
